import { Box, BoxProps, Button, Grid, Stack, Typography } from "@mui/material";
import { usePermissionsContext } from "../../../../../../../contexts/PermissionsContext";
import { useContext } from "react";
import { AuthContext } from "../../../../../../../contexts/AuthContext";
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import { useState } from "react";
import { IDetalharAgrotoxico } from "../../../../../../../types/api/receituarioAgronomico/detalhar-agrotoxico";
import { DadosTitulosItems } from "../../index";
import DialogEditarAgrotoxico from "./DialogEditarAgrotoxico";
import { usePermission } from "../../../../../../../components/PermissionGuard";
import { enqueueSnackbar } from "notistack";

export default function Editar({ boxStyle, detalhe }: CardDadosAgrotoxicoProps) {
    const { verificarPermissoes } = usePermissionsContext();
    const { token } = useContext(AuthContext);
    const [openEdit, setOpenEdit] = useState(false);

    const agrotoxico: IDetalharAgrotoxico = detalhe;

    const handleEditSubmit = () => {
        setOpenEdit(false);
    };

    const handleConsultarBula = async () => {
        if (agrotoxico?.arquivo_bula_id && agrotoxico.arquivo_bula_id !== 0) {
            try {
                const url = `${process.env.REACT_APP_API}/api/imprimir-arquivo/${agrotoxico.arquivo_bula_id}?token=${token}`;
                window.open(url, '_blank');
            } catch (error) {
                enqueueSnackbar('Erro ao consultar bula', { variant: 'error' });
            }
        }
    };


    return (
        <Box {...boxStyle}>
            <Stack direction="row" justifyContent="space-between" alignItems="center" mb={2}>
                <Typography variant="h6" >Dados do Agrotóxico</Typography>
            </Stack>
            <Grid container spacing={2}>
                <Grid size={{xs: 12, md: 6}}>
                    <DadosTitulosItems titulo="Marca Comercial" valor={agrotoxico?.marca_comercial ?? "-"} />
                </Grid>
                <Grid size={{xs: 12, md: 3}}>
                    <DadosTitulosItems titulo="Classe" valor={agrotoxico?.classe ?? "-"} />
                </Grid>
                <Grid size={{xs: 12, md: 3}}>
                    <DadosTitulosItems titulo="Orgânico" valor={agrotoxico?.organico ?? "-"} />
                </Grid>
                <Grid size={{xs: 12, md: 6}}>
                    <DadosTitulosItems titulo="Titular do Registro" valor={agrotoxico?.titular_registro ?? "-"} />
                </Grid>
                <Grid size={{xs: 12, md: 6}}>
                    <DadosTitulosItems titulo="Modo de Ação" valor={agrotoxico?.modo_acao ?? "-"} />
                </Grid>
                <Grid size={{xs: 12, md: 6}}>
                    <DadosTitulosItems titulo="Ingrediente Ativo" valor={agrotoxico?.ingrediente_ativo?.nome ?? "-"} />
                </Grid>
                <Grid size={{xs: 12, md: 6}}>
                    <DadosTitulosItems titulo="Classe Toxicológica" valor={agrotoxico?.classe_toxicologica ?? "-"} />
                </Grid>
                <Grid size={{xs: 12, md: 6}}>
                    <DadosTitulosItems titulo="Classe Ambiental" valor={agrotoxico?.classe_ambiental ?? "-"} />
                </Grid>
                <Grid size={{xs: 12, md: 12}}>
                    <DadosTitulosItems titulo="Empresa / País / Tipo" valor={agrotoxico?.empresa_pais_tipo ?? "-"} />
                </Grid>
            </Grid>
            <Stack 
                direction="row" 
                justifyContent={
                    (agrotoxico?.arquivo_bula_id && agrotoxico.arquivo_bula_id !== 0) 
                        ? "space-between" 
                        : "flex-end"
                } 
                alignItems="center" 
                mt={2}
            >
                {agrotoxico?.arquivo_bula_id && agrotoxico.arquivo_bula_id !== 0 && (
                    <Button
                        variant="outlined"
                        size="small"
                        startIcon={<DescriptionOutlinedIcon />}
                        sx={{ fontSize: '0.75rem' }}
                        onClick={handleConsultarBula}
                    >
                        Consultar bula
                    </Button>
                )}
                {verificarPermissoes('Receituário Agronômico', 'Agrotóxicos » Editar agrotóxico') && (
                    <Button
                        variant="contained"
                        size="small"
                        startIcon={<EditOutlinedIcon />}
                        sx={{ fontSize: '0.75rem' }}
                        onClick={() => setOpenEdit(true)}
                    >
                        Editar
                    </Button>
                )}
            </Stack>
            <DialogEditarAgrotoxico
                open={openEdit}
                onClose={() => setOpenEdit(false)}
                defaultValue={agrotoxico}
                onSubmit={handleEditSubmit}
            />
        </Box>
    );
}

interface CardDadosAgrotoxicoProps {
    boxStyle: BoxProps;
    codigo: string;
    detalhe: IDetalharAgrotoxico;
}

